export default "__VITE_ASSET__CKQ5ariz__"